"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestNoTypeExportWithouthConst = exports.UNCONFIGURED_DOMAIN = exports.UNCLASSIFIED_DOMAIN = exports.GoogleChannels = exports.isFargateServiceConfigWithoutScalingOptions = exports.isFargateServiceConfigWithScalingOptions = exports.isFargateServiceConfig = exports.isFargateWithoutScalingOptions = exports.isFargateWithScalingOptions = exports.isLambdaServiceConfig = exports.DiscoverySetting = void 0;
exports.getFargateStackParameters = getFargateStackParameters;
var DiscoverySetting;
(function (DiscoverySetting) {
    DiscoverySetting["ON"] = "on";
    DiscoverySetting["OFF"] = "off";
})(DiscoverySetting || (exports.DiscoverySetting = DiscoverySetting = {}));
const isLambdaServiceConfig = (config) => {
    return config?.computeService === 'LAMBDA';
};
exports.isLambdaServiceConfig = isLambdaServiceConfig;
const isFargateWithScalingOptions = (options) => {
    return options.scalingLimits !== null;
};
exports.isFargateWithScalingOptions = isFargateWithScalingOptions;
const isFargateWithoutScalingOptions = (options) => {
    return options.scalingLimits === null;
};
exports.isFargateWithoutScalingOptions = isFargateWithoutScalingOptions;
const isFargateServiceConfig = (config) => {
    return config?.computeService === 'FARGATE';
};
exports.isFargateServiceConfig = isFargateServiceConfig;
const isFargateServiceConfigWithScalingOptions = (config) => {
    return (0, exports.isFargateServiceConfig)(config) && (0, exports.isFargateWithScalingOptions)(config.options);
};
exports.isFargateServiceConfigWithScalingOptions = isFargateServiceConfigWithScalingOptions;
const isFargateServiceConfigWithoutScalingOptions = (config) => {
    return (0, exports.isFargateServiceConfig)(config) && (0, exports.isFargateWithoutScalingOptions)(config.options);
};
exports.isFargateServiceConfigWithoutScalingOptions = isFargateServiceConfigWithoutScalingOptions;
function getFargateStackParameters(fargateServiceConfig) {
    if ((0, exports.isFargateServiceConfigWithScalingOptions)(fargateServiceConfig)) {
        return {
            cpu: fargateServiceConfig.options.sizing.cpu,
            memoryLimitMiB: fargateServiceConfig.options.sizing.memoryLimitMiB,
            capacityProviderStrategies: fargateServiceConfig.options.capacityProviderStrategies ?? [],
            scalingLimits: fargateServiceConfig.options.scalingLimits
        };
    }
    if ((0, exports.isFargateServiceConfigWithoutScalingOptions)(fargateServiceConfig)) {
        return {
            cpu: fargateServiceConfig.options.sizing.cpu,
            memoryLimitMiB: fargateServiceConfig.options.sizing.memoryLimitMiB,
            capacityProviderStrategies: undefined,
            scalingLimits: undefined
        };
    }
    throw new Error('No Fargate Service Config found, using defaults. To remove this warning, add configuration for this service in your config file.');
}
var GoogleChannels;
(function (GoogleChannels) {
    GoogleChannels["quarterly"] = "quarterly";
    GoogleChannels["beta"] = "beta";
})(GoogleChannels || (exports.GoogleChannels = GoogleChannels = {}));
/** for types that are not classified by the {@link DomainMap} in the config */
exports.UNCLASSIFIED_DOMAIN = 'Unclassified';
/** for types that are classified, but the specific instance is not properly configured with the `domain` attribute */
exports.UNCONFIGURED_DOMAIN = 'Unconfigured';
exports.TestNoTypeExportWithouthConst = '451';
